'use strict';

DoohApps
.directive('timePicker2', ['$filter', function ($filter) {
    return {
        restrict: 'A',
        scope: {
            isallday: '=',
            defaultTime: '=',
            onChange: '&',
            showTime: '=',
            placement: '=?',
            isDisabled: '=?',
            timeChanged: '=?'
        },
        template: '<div style="display: flex;"><form><input type="text" class="form-control" ng-maxlength="8" maxlength="8"  ng-model="showTime" ng-disabled="isDisabled"></form></div>',
        replace:false,
        link: function (scope, element, attrs) {

            var form1 = element.find('form').eq(0);
            scope.formCtrl = form1.controller('form');
            
            var regex12 = /^([0-1]?\d):([0-5]\d)\s?(?:AM|PM){1}$/i;
            var regex24 = /^([0-1]?\d):([0-5]\d)$/i;
            scope.showInput = false;
            
            var getShowTime = function (itime) {
                var time = itime.split(':');
                var tmpDate = new Date();
                var date = new Date(tmpDate.getFullYear(), tmpDate.getMonth(), tmpDate.getDate(), time[0], time[1], 0);
                return $filter('date')(date, localStorage['TimeFormat']);
            }

            var setTime = function (leadzero, val, clock12) {
                if (leadzero && val[1] == ':')
                    val = '0' + val;
                else if (!leadzero && val[0] == '0' && val[1] != ':')
                    val = val.substring(1);

                scope.showTimeOrg = scope.showTime = val;

                if (clock12) {
                    var dt = moment(val, localStorage['TimeFormat']).format('HH:mm');
                    scope.defaultTime = dt;
                }
                else scope.defaultTime = val;
            }

            var id = attrs.id;
            scope.invalid = false;
            
            var showDate = getShowTime(scope.defaultTime);
            scope.showTimeOrg = showDate;
            var clock12 = false;
            if (localStorage['TimeFormat'].indexOf('a') != -1) {
                clock12 = true;
            }
            var leadzero = true;
            var hcount = (localStorage['TimeFormat'].match(new RegExp('h', 'g')) || []).length;
            var Hcount = (localStorage['TimeFormat'].match(new RegExp('H', 'g')) || []).length;
            if (hcount == 1 || Hcount == 1) leadzero = false;
            
            //scope.inputTime = showDate;
            var validTime = function (time, clock12) {
                if (clock12) return regex12.test(time);
                return regex24.test(time);
            }
            var placement = 'bottom';
            if (scope.placement != undefined) placement = scope.placement;

            scope.showTime = showDate;
            
            jQuery('#' + id).clockpicker({
                placement: placement,
                align: 'left',
                donetext: 'Done',
                'default': scope.defaultTime,
                autoclose: true,
                twelvehour: clock12,
                leadzero: leadzero,
                beforeShow: function (e) {
                    scope.showInput = true;
                    scope.$apply();
                },
                afterHide: function (val) {
                    if (scope.formCtrl.$pristine)
                        return;
                    scope.showInput = true;
                    scope.$apply();
                    
                    scope.$apply(function (scope) {
                        scope.showInput = false;
                        var test = validTime(val, clock12);
                        if (!test) scope.showTime = scope.showTimeOrg;
                        else {
                            if (clock12) {
                                val = val.replace(/a/g, 'A').replace(/p/g, 'P').replace(/m/g, 'M');
                                var pindex = val.indexOf('PM');
                                var aindex = val.indexOf('AM');
                                if (pindex != -1) {
                                    if(val[pindex-1] != ' ') val = val.substring(0,pindex) + ' ' + val.substring(pindex)
                                }
                                if (aindex != -1) {
                                    if (val[aindex - 1] != ' ') val = val.substring(0, aindex) + ' ' + val.substring(aindex)
                                }
                                if ((val.split(':')[0] * 1) > 12) {
                                    var h = (val.split(':')[0] % 12) || 12;
                                    var ampm = val.split(':')[0] < 12 ? 'AM' : 'PM';
                                    val = val.replace(val.split(':')[0], h + '').replace(pindex != -1 ? 'PM':'AM',ampm);
                                }
                            }

                            setTime(leadzero, val, clock12);
                        }
                    });
                    if (scope.timeChanged != undefined)
                        scope.timeChanged = true;
                    scope.onChange();
                },
                afterDone: function (val) {
                    if (scope.formCtrl.$pristine)
                        return;
                    scope.showInput = false;
                    scope.$apply(function (scope) {
                        scope.showInput = false;
                        setTime(leadzero, val, clock12);
                    });
                    if (scope.timeChanged != undefined)
                        scope.timeChanged = true;
                    scope.onChange();
                }
            });

            scope.$watch(function () { return scope.defaultTime }, function (newValue) {
                var showTime = getShowTime(scope.defaultTime);
                scope.showTime = showTime;
            });

            scope.$watch(function () { return scope.isallday }, function (newValue) {
                jQuery(element).first().show();
                if (scope.isallday) jQuery(element).first().hide();
            });

        }
    }
}]);